export const AttendanceStatus = {
  PRESENT: "present",
  ABSENT: "absent",
  LATE: "late",
  HALF_DAY: "half_day",
  LEAVE: "leave",
  HOLIDAY: "holiday",
  WEEKLY_OFF: "weekly_off",
  UNKNOWN: "unknown"
} as const;

export const AttendancePunchSource = {
  MANUAL: "manual",
  BIOMETRIC: "biometric",
  API: "api"
} as const;

export const AttendancePunchType = {
  CHECK_IN: "check_in",
  CHECK_OUT: "check_out",
  BREAK_IN: "break_in",
  BREAK_OUT: "break_out"
} as const;

export const AttendanceDutyType = {
  REGULAR: "regular",
  OVERTIME: "overtime",
  ON_CALL: "on_call"
} as const;
